/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets CheckFundExhaustedResponse from api:
 * /v1/ua/checkfundExhausted
 *
 * @param {string} intakeApplicationTypeId.
 * @param {any} callback function to call once this function has finished
 */
const fetchCheckfundExhaustedUtil = (intakeApplicationTypeId, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/checkfundExhausted?intakeApplicationTypeId=${intakeApplicationTypeId}`,
    models.CheckFundExhaustedResponse
  );
};

export { fetchCheckfundExhaustedUtil };
